import { useAuth0 } from '@auth0/auth0-react'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'

import { LoginScreen, PcLoginGuide } from '@/components/screens/login-screen'
import { env } from '@/lib/env'

function SignInPage() {
  const { isAuthenticated, loginWithRedirect } = useAuth0()
  const navigate = useNavigate()
  const [forceShowLogin, setForceShowLogin] = useState(false)

  useEffect(() => {
    if (isAuthenticated) {
      void navigate({ to: '/', replace: true })
    }
  }, [isAuthenticated, navigate])

  if (!isMobile && !forceShowLogin) {
    return (
      <PcLoginGuide
        managerClientUrl={env.managerClientUrl}
        onShowLogin={() => {
          setForceShowLogin(true)
        }}
      />
    )
  }

  return (
    <LoginScreen
      onLogin={() => {
        void loginWithRedirect()
      }}
    />
  )
}

export const Route = createFileRoute('/sign_in')({ component: SignInPage })
